//
// # Primitives Namespace
//

// Primitives
// For each, rename the "main drawer type", and also export everything else.
export { ArcEntity as Arc } from "./arc";
export * from "./arc";

export { EllipseEntity as Ellipse } from "./ellipse";
export * from "./ellipse";

export { PathEntity as Path } from "./path";
export * from "./path";

export { PolygonEntity as Polygon } from "./polygon";
export * from "./polygon";

export { RectEntity as Rect } from "./rect";
export * from "./rect";

export { TextEntity as Text } from "./text";
export * from "./text";

// The main union types
export * from "./primitive";
